export interface ITopBannerProps {
  cdnUrl: string;
}
